var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62654 17.3993C9.41214 17.9521 10.7861 18.8014 10.8442 18.8375C11.0139 18.9424 11.2312 19 11.4554 19C11.6802 19 11.8972 18.9424 12.0657 18.8375C12.1239 18.8014 13.4981 17.9521 14.284 17.3993C20.1048 13.308 22.8485 8.5533 21.6236 4.68095C20.9274 2.47911 18.989 1 16.8002 1C15.409 1 14.0058 1.53801 12.9501 2.47577C12.1517 3.18487 11.6112 4.30651 11.4557 4.65564C11.3141 4.33823 10.7697 3.19461 9.96072 2.47577C8.90472 1.53773 7.501 1 6.11007 1C3.92159 1 1.98319 2.47911 1.28689 4.68067C0.0620384 8.55302 2.80578 13.308 8.62654 17.3993ZM2.1309 4.94745C2.71009 3.11588 4.3091 1.88519 6.11007 1.88519C7.28707 1.88519 8.4766 2.34169 9.37291 3.13758C10.1429 3.82164 10.6651 5.05595 10.6654 5.05595C10.8904 5.68771 11.2568 5.78201 11.4554 5.78201C11.654 5.78201 12.0204 5.68743 12.2368 5.07737C12.2424 5.06485 12.7648 3.82414 13.5385 3.13758C14.4342 2.34169 15.6232 1.88519 16.8005 1.88519C18.6014 1.88519 20.2007 3.11588 20.7799 4.94773C21.8824 8.43312 19.2638 12.8168 13.7749 16.6749C13.011 17.2121 11.6148 18.0753 11.6006 18.0842C11.5825 18.0959 11.5316 18.1148 11.4557 18.1148C11.3797 18.1148 11.3283 18.0953 11.3099 18.0842C11.296 18.0753 9.90035 17.2124 9.13617 16.6749C3.64729 12.817 1.02873 8.43284 2.1309 4.94745Z",
    fill: "#3D4151",
    stroke: "#3D4151",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2b37f511fd85d165f79520c8c39c536b.svg";
export { ForwardRef as ReactComponent };